// Arabic translations
export default {
  // Navbar
  'nav.home': 'الرئيسية',
  'nav.about': 'عني',
  'nav.services': 'الخدمات',
  'nav.transformations': 'التحولات',
  'nav.feedback': 'آراء العملاء',
  'nav.packages': 'الباقات',
  'nav.faq': 'الأسئلة الشائعة',
  'nav.contact': 'اتصل بنا',
  
  // Landing
  'landing.title.accent': 'مش تدريب اون لاين',
  'landing.title.text': 'دي رحله تغير جسمك وعقليتك وعاداتك',
  'landing.subtitle': ' ',
  'landing.cta.start': 'ابدأ التحول ←',
  'landing.cta.view': 'عرض البرامج ↓',
  'landing.video.title': 'خدمات التدريب الخاصة بي',
  'landing.video.subtitle': 'تعرف على كيف يمكنني مساعدتك في تحقيق أهدافك اللياقة البدنية',
  'landing.video.cta': 'انقر للتشغيل',
  'landing.video.hint.personalized': 'برامج تدريب شخصية',
  'landing.video.hint.hd': 'HD',
  'landing.video.hint.service': 'نظرة عامة على الخدمة',
  'landing.video.caption.personalized': 'برامج تدريب شخصية',
  'landing.video.caption.watch': 'شاهد المزيد',
  'landing.video.caption.stories': 'مشاهدة التحولات',
  
  // About
  'about.title': 'من',
  'about.me': 'أنا',
  'about.description': 'أقدم لك جميع خدمات التدريب أونلاين على أسس علمية وبأعلى جودة ممكنة',
  'about.qualification.1': 'طالب علاج طبيعي',
  'about.qualification.2': 'مدرب شخصي معتمد',
  'about.qualification.3': 'أخصائي تغذية رياضية معتمد من البورد الأمريكي',
  'about.qualification.4': 'صانع محتوى على جميع منصات التواصل الاجتماعي',
  'about.certified_coach': 'مدرب معتمد',
  'about.image_alt': 'مدرب محترف',
  
  // Services
  'services.title': 'ليه د. فارس',
  'services.subtitle': '',
  'services.diet.title': 'التمرين',
  'services.diet.description': '',
  'services.diet.feature.1': 'جدول تدريب بالعلم ومخصص ليك',
  'services.diet.feature.2': 'اداه تبديل التمارين عشان لو غيرت جيم متتأثرش',
  'services.diet.feature.3': 'فديوهات شرح لدكتور فارس لكل تمرين',
  'services.diet.feature.4': 'جداول تدريب للجيم او للبيت حسب الحاجه',
  'services.workout.title': 'الدايت',
  'services.workout.description': '',
  'services.workout.feature.1': 'دايت مناسب ليومك وحياتك وميزانيتك',
  'services.workout.feature.2': 'اداه تبديل الاكل عشان التنوع وتقليل الملل',
  'services.workout.feature.3': 'بدايل بنفس السعرات عشان تحافظ علي الاستمراريه',
  'services.tools.title': 'متابعه فعليه',
  'services.tools.description': '',
  'services.tools.feature.1': 'ارشادات لكل خطوه ليك عشان تفهم نفسك',
  'services.tools.feature.2': 'حل اي مشكله تواجهك عشان نعالج عاداتك',
  'services.tools.feature.3': 'متابعه دوريه عشان نضمن استمرارك',
  'services.cta.view': 'عرض الباقات',
  'services.cta.looking': 'هل تبحث عن برنامج مخصص لا يناسب هذه الفئات؟',
  
  // Transformations
  'transformations.title': 'التحولات',
  'transformations.subtitle': 'نتائج حقيقية من عملاء حقيقيين اتبعوا البرنامج',
  'transformations.before': 'قبل',
  'transformations.after': 'بعد',
  'transformations.read.more': 'اقرأ المزيد',
  'transformations.read.less': 'اقرأ أقل',
  'transformations.stats.title': 'إحصائيات التحول',
  'transformations.stats.weight': 'فقدان الوزن',
  'transformations.stats.bodyfat': 'تقليل دهون الجسم',
  'transformations.client.1.name': 'يوسف الناظر',
  'transformations.client.1.role': 'طالب وبيشتغل',
  'transformations.client.1.duration': '3 أشهر',
  'transformations.client.1.achievement': 'اكتساب العضلات مع الحد الأدنى من الدهون',
  'transformations.client.1.story': 'طالب في ٣ ث تمريض وبيشتغل في صيدلية ما يعادل 7 ساعات يوميا وعنده مشكلة تجنح لوح الكتف ورغم كدا قدرنا نعمل جداول مناسبة لظروف يومه ويزيد ٦ كيلو عضلات صافي ولسه مستمر عشان يوصل لأحسن نسخة من نفسه',
  'transformations.client.2.name': 'فارس مسعد',
  'transformations.client.2.role': 'طالب هندسة',
  'transformations.client.2.duration': 'شهرين',
  'transformations.client.2.achievement': 'فقدان الدهون مع الحفاظ على العضلات',
  'transformations.client.2.story': 'طالب في كليه الهندسة ف اغلب يومه محاضرات وقعدة بوضع مش مريح فترات طويلة مما سببله دوران للكتفين ده غير ضيق الوقت بسبب المحاضرات والدراسة ورغم كدة قدر يخس ٨ كيلو دهون في شهرين ولسه مكمل لأنه لسه عاوز النسخة الأفضل منه',
  
  // Feedback
  'feedback.title': 'آراء العملاء',
  'feedback.subtitle': 'ماذا يقول عملاؤنا عنا',
  'feedback.ariaLabel.gallery': 'معرض شهادات العملاء',
  'feedback.ariaLabel.prevButton': 'عرض الشهادات السابقة',
  'feedback.ariaLabel.nextButton': 'عرض المزيد من الشهادات',
  'feedback.ariaLabel.viewImage': 'عرض صورة الشهادة',
  'feedback.navigation.instructions': 'استخدم مفاتيح الأسهم اليسرى واليمنى للتنقل خلال صور الشهادات. اضغط على Enter على صورة لعرضها في وضع ملء الشاشة.',
  'feedback.error.loadingImage': 'فشل في تحميل الصورة',
  'feedback.announcement.left': 'تم التمرير لليسار',
  'feedback.announcement.right': 'تم التمرير لليمين',
  
  // Packages
  'packages.title': 'الباقات',
  'packages.subtitle': 'اختر الباقة المناسبة لك',
  'packages.features': 'جميع الميزات تشمل:',
  'packages.tier': 'اختر مستواك:',
  'packages.cta': 'ابدأ الآن',
  'packages.bestvalue': 'أفضل قيمة',
  'packages.popular': 'الأكثر شعبية',
  'packages.free_consultation': 'جميع الباقات تشمل استشارة أولية مجانية',
  'packages.contact_us': 'اتصل بنا',
  'packages.discount': 'خصم 50%',
  'packages.installment': 'يمكن الدفع على دفعتين',
  'packages.egp': 'جنيه',
  'packages.usd': 'دولار',
  'packages.eur': 'يورو',
  'packages.gbp': 'جنيه إسترليني',
  'packages.sar': 'ريال سعودي',
  'packages.aed': 'درهم إماراتي',
  'packages.kwd': 'دينار كويتي',
  'packages.qar': 'ريال قطري',
  'packages.bhd': 'دينار بحريني',
  'packages.omr': 'ريال عماني',
  'packages.jod': 'دينار أردني',
  'packages.lbp': 'ليرة لبنانية',
  'packages.iqd': 'دينار عراقي',
  'packages.syp': 'ليرة سورية',
  'packages.yer': 'ريال يمني',
  'packages.ils': 'شيكل',
  'packages.mad': 'درهم مغربي',
  'packages.dzd': 'دينار جزائري',
  'packages.tnd': 'دينار تونسي',
  'packages.lyd': 'دينار ليبي',
  'packages.sdg': 'جنيه سوداني',
  'packages.sos': 'شلن صومالي',
  'packages.djf': 'فرنك جيبوتي',
  'packages.mro': 'أوقية موريتانية',
  'packages.get_plan': 'احصل على خطة {0}',
  'packages.testing.title': 'باقة التجربة',
  'packages.testing.duration': 'المدة: شهر + شهر هدية',
  'packages.testing.suitableFor': 'مناسبة لو هدفك بسيط أو حابب تبدأ بالتجربة.',
  'packages.development.title': ' باقة التطور',
  'packages.development.duration': 'المدة: 3 شهور + شهر هدية',
  'packages.development.suitableFor': 'ممتازة لو ناوي تبدأ تغيير فعلي وتوصل لهدف واضح.',
  'packages.journey.title': ' باقة الرحلة',
  'packages.journey.duration': 'المدة: 6 شهور + شهر هدية',
  'packages.journey.suitableFor': 'مناسبة لو ناوي تختفي وترجع شخص مختلف تمامًا.',
  'packages.silver': 'فضي',
  'packages.gold': 'ذهبي',
  'packages.silver.benefit.1': 'متابعة واتساب أسبوعية',
  'packages.silver.benefit.2': 'الرد على الأسئلة حسب الوقت المتاح',
  'packages.gold.benefit.1': 'متابعة يومية',
  'packages.gold.benefit.2': 'أولوية في الرد على الأسئلة',
  'packages.gold.benefit.3': 'فيديو كول شهري حسب رغبة العميل لمتابعة التطور (للشباب فقط)',
  'packages.feature.1': 'جدول تدريب حسب أوقات فراغك (بيت / جيم)',
  'packages.feature.2': 'لينكات تمرين بجودة عالية وشرح مفصل',
  'packages.feature.3': 'أداة تبديل تمارين حسب الأجهزة المتاحة',
  'packages.feature.4': 'جدول تغذية مفصل مبني على أكلك المفضل',
  'packages.feature.5': 'أداة تبديل أكل عشان التنويع مع التزام بالدايت',
  'packages.feature.6': 'تصحيح بعض المشاكل القوامية (تجنح لوح الكتف، استدارة الكتفين)',
  'packages.feature.7': 'فيديوهات إرشادية لشرح الرحلة',
  'packages.feature.8': 'كتاب نصائح الدايت',
  'packages.feature.9': 'خطة مكملات حسب رغبة العميل',
  'packages.feature.10': 'متابعة الأداء عن طريق الفيديوهات',
  
  // WhatsApp Messages
  'whatsapp.general': 'أنا مهتم بمعرفة المزيد عن خدمات التدريب الخاصة بك.',
  'whatsapp.package': 'أنا مهتم بخطة {0} - {1}.',
  
  // FAQ
  'faq.title': 'الأسئلة الشائعة',
  'faq.subtitle': 'إجابات على أسئلتك الأكثر شيوعاً',
  'faq.more': 'هل لديك المزيد من الأسئلة؟ نحن هنا للمساعدة!',
  'faq.contact': 'اتصل بنا',
  'faq.q1': 'مين يقدر ينضم للبرنامج؟',
  'faq.a1': 'اي حد حابب يغير شكل حياته وجسمه ويكون نسخه افضل ولكن بشرط الا يعاني من اي (إصابات او أمراض) شديدة تمنعه من التمرين او الالتزام علي دايت إلا بعلم الطبيب الخاص بيك',
  'faq.q2': 'هل بتمرن بنات؟',
  'faq.a2': 'ايوا بس المتابعه بدون صور ولو حبيتي ممكن يبقي التواصل من خلال الوالد او الأخ',
  'faq.q3': 'بستلم البرنامج فى قد اية؟',
  'faq.a3': 'من يوم ل ٣ أيام كحد اقصي',
  'faq.q4': 'إيه سياسة الاسترجاع؟',
  'faq.a4': 'يمكنك استرداد كامل مبلغ الاشتراك اذا لم يتم استلام اى خطط , لاكن اذا تم استلام البرنامج لا يسمح باسترداد المبلغ',
  'faq.q5': 'هل يوجد متابعة و فحوصات؟',
  'faq.a5': 'طبعا في الباقه الفضيه بتابعك كل أسبوع وفالباقه الذهبيه متابعه يوميه',
  'faq.q6': 'الاشتراك بيبدأ امتى؟',
  'faq.a6': 'اول ما يوصلك جداول الشغل',
  'faq.q7': 'هل لازم أنشر تحول العميل؟',
  'faq.a7': 'يفضل بس لو العميل مش حابب فا دي خصوصيه وأنا مقدرش أتعداها',
  
  // Footer
  'footer.rights': 'جميع الحقوق محفوظة',
  'footer.privacy': 'سياسة الخصوصية',
  'footer.terms': 'الشروط',
  'footer.cookies': 'ملفات تعريف الارتباط',
  'footer.connect': 'تواصل معنا'
}; 